import { AvatarGranite } from 'components';

export const AvatarNameCell = ({ name }: { name: string }) => {
  return (
    <div className="flex items-center justify-start gap-4">
      <AvatarGranite
        width="w-8"
        height="h-8"
        name={name}
        fontSize={'text-xs'}
      />
      <h2 className="text-sm text-content-base-default">{name}</h2>
    </div>
  );
};
